(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/ticket-partner/assets/react/pages/my-orders/components/order-sum.js') >= 0) return;  svs.modules.push('/modules/ticket-partner/assets/react/pages/my-orders/components/order-sum.js');
"use strict";


const _svs$ui$reactTable = svs.ui.reactTable,
  TableRow = _svs$ui$reactTable.TableRow,
  TableCell = _svs$ui$reactTable.TableCell;
const _svs$ticket_partner$m = svs.ticket_partner.myOrders.constants.TEXTS.TABLE_FOOTER,
  SUM = _svs$ticket_partner$m.SUM,
  SEK = _svs$ticket_partner$m.SEK;
const OrderSum = _ref => {
  let batches = _ref.batches;
  const sum = batches === null || batches === void 0 ? void 0 : batches.reduce((acc, _ref2) => {
    let numberOfVouchers = _ref2.numberOfVouchers,
      singleVoucherValue = _ref2.singleVoucherValue;
    return numberOfVouchers * singleVoucherValue + acc;
  }, 0);
  return React.createElement(TableRow, {
    footer: true
  }, React.createElement(TableCell, {
    className: "sum-align",
    colspan: "4"
  }, React.createElement("span", {
    className: "f-bold"
  }, SUM, "\xA0", svs.utils.format.Currency(sum), "\xA0", SEK)));
};
svs.ticket_partner.myOrders.components.OrderSum = OrderSum;

 })(window);